import Table from '@/components/Table/Table.jsx'
import TableChooseProduct from '../_PRODUCT/TableChooseProduct.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

const TableChooseSf = (props) => {
    const map = useMapContext()

    const columns = [
        {
            title: '功能域',
            dataIndex: 'fmNamePath',
            component: <Table.ViewText />,
        },

        'BCT' === map.data.prjTypeCode && {
            title: '界面方案',
            dataIndex: 'uiCase',
            component: <Table.ViewText />,
        },

        {
            title: '系统功能代码',
            dataIndex: 'sfNo',
            component: <Table.ViewText />,
        },

        {
            title: '系统功能名称',
            dataIndex: 'sfName',
            component: <Table.ViewText />,
        },

        {
            title: '系统功能类型',
            dataIndex: 'sfTypeName',
            component: <Table.ViewText />,
        },
    ].filter(a => a)

    return (
        <TableChooseProduct
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseSf
